import '../../styles/index.scss';
import { docReady } from '../helpers/docReady';
import { customCursor } from './custom-cursor';
import { hoverList } from '../sections/hover-list';
docReady(() => {
    // console.log('Global JS Ready');
    customCursor();
    hoverList();
});
